import { render, staticRenderFns } from "./TipoEntrada.vue?vue&type=template&id=46c042c2"
import script from "./TipoEntrada.vue?vue&type=script&lang=js"
export * from "./TipoEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports